<template>
  <section class="c-nav-thumbnails">
    <figure
      v-for="illustration in illustrations"
      :key="illustration.id"
      :class="{
        'is-active' : activeIllustration === illustration.id,
        'has-focus' : hasFocus === true && focusIds.includes(illustration.id),
      }"
      @click="setActiveIllustration(illustration.id)"
      @keypress.enter="setActiveIllustration(illustration.id)"
      class="c-thumb"
      tabindex="0"
    >
      <responsive-image
        :id="illustration.image[0].id"
        class="c-thumb__img"
      />
      <figcaption class="c-thumb__caption">
        {{ illustration.name }}
      </figcaption>
    </figure>
  </section>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

import Illustration from '@/models/Illustration';
import Residence from '@/models/Residence';
import Shape from '@/models/Shape';

import ResponsiveImage from '@/components/ResponsiveImage.vue';

export default {
  name: 'SelectorThumbnails',
  components: {
    ResponsiveImage,
  },
  props: {
    illustrationIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hasFocus: false,
      focusIds: [],
    };
  },
  computed: {
    illustrations() {
      return Illustration
        .query()
        .with('image')
        .with('building')
        .whereIdIn(this.illustrationIds)
        .get();
    },
    activeIllustration() {
      return this.$store.state.entities.illustrations.activeIllustration;
    },
    residences() {
      return Residence
        .query()
        .withAll()
        .get();
    },
    shapes() {
      return Shape
        .query()
        .withAll()
        .get();
    },
  },
  created() {
    EventBus.$on('residence-focus', focus => {
      this.hasFocus = focus.hasFocus;
      this.focusIds = focus.illustrationIds;
    });
  },
  methods: {
    setActiveIllustration(id) {
      Illustration.commit(state => {
        state.activeIllustration = id;
      });
    },
  },
};
</script>
